import type { UseMutationOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import type { ApiError } from "./types";
import toast from "react-hot-toast";

export const useApiMutate = <TData, TReturnData = unknown>(
  options: {
    mutationFn: (data: TData) => Promise<TReturnData>;
  } & Omit<UseMutationOptions<TReturnData, ApiError, TData>, "mutationFn">,
) => {
  const { onError, ...rest } = options;

  return useMutation({
    ...rest,
    mutationFn: options.mutationFn,
    onError: (error, variables, context) => {
      if (onError) {
        onError(error, variables, context);
        return;
      }

      if (error?.status === 429) {
        toast.error("Too many requests. Please try again later.");
        return;
      }

      if (error?.status === 422) {
        toast.error("Captcha verification failed. Please try again.");
        return;
      }

      toast.error("An unexpected error occurred. Please try again.");
    },
  });
};
